import styled from 'styled-components';

export const PricesIndexsListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
